import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App, DevApp } from "./App.js";
import "./styles.css";
import "./responsive.css";
import "./design-system.css";
import "./admin.css";
import "./analysis.css";
import "./configuration.css";
import "./review.css";
import "./dashboard.css";
import "./history.css";

const devAuthEnabled = import.meta.env.VITE_DEV_AUTH_ENABLED === "true";
const devToken = import.meta.env.VITE_DEV_AUTH_TOKEN ?? "dev-agent-token";
const devUserName = import.meta.env.VITE_DEV_USER_NAME ?? "Usuario local";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {devAuthEnabled
      ? <DevApp token={devToken} name={devUserName} />
      : <App />}
  </StrictMode>,
);
